// extracted by css-extract-rspack-plugin
export default {"root":"_3RbGWELIhd8Jfjn6WhHsuO","frame":"_2bv7SpOGh315GhudM4SIdG"};